import React, { useState, useCallback, useEffect } from "react";
import style from "./Tab5.module.scss";
import { v4 } from "uuid";
import TabList from '../../comm/global/components/TabList';
import { wait } from "../../comm/comm";
import WeatherWidget from "../../comm/global/components/WeatherWidget";
import AlbumItem from "../../comm/global/components/AlbumItem";
import * as YStyleds from "../../Styleds";
import DateTimeSel from "../../comm/global/components/DateTimeSel";
import EventItem from "../../comm/global/components/EventItem";
import Folder from "../../comm/global/components/Folder";
import FriendsIcon from "../../comm/global/components/FriendsIcon";
import Links from "../../comm/global/components/Links";
import LogItem from "../../comm/global/components/LogItem";
import MeetPoint from "../../comm/global/components/MeetPoint";
import MemberLimit from "../../comm/global/components/MemberLimit";
import NoticeView from "../../comm/global/components/NoticeView";
import PotItem from "../../comm/global/components/PotItem";
import PotViewItem from "../../comm/global/components/PotViewItem";
import SelRewildingMode from "../../comm/global/components/SelRewildingMode";
import FriendInfo from "../../comm/global/components/FriendInfo";
import PlacesInput from "../../comm/global/components/PlacesInput";
import Myselect from "../../comm/global/components/Myselect";
import styled from "styled-components";
const Tab5 = ({ loginData, set_loginData, addModalType, set_menuVisiable, set_bottomSheetOpen }) => {
    const [data, set_data] = useState({ name: "", pot: null, bg: null, member: 5, meetPlace: "" });
    const items = [
        { id: 0, "type": "user", "record": false, "name": "九份", "lat": 25.1094, "lng": 121.8453 },
        { id: 1, "type": "user", "record": false, "name": "金瓜石", "lat": 25.1155, "lng": 121.8584 },
        { id: 2, "type": "user", "record": false, "name": "猴硐", "lat": 25.0981, "lng": 121.8143 },
        { id: 3, "type": "user", "record": false, "name": "瑞芳", "lat": 25.1089, "lng": 121.8042 },
        { id: 4, "type": "user", "record": false, "name": "石碇", "lat": 24.9536, "lng": 121.6373 },
        { id: 5, "type": "user", "record": false, "name": "大溪老街", "lat": 24.9316, "lng": 121.2878 },
        { id: 6, "type": "user", "record": false, "name": "大湖草原", "lat": 24.4442, "lng": 121.3063 },
        { id: 7, "type": "user", "record": false, "name": "石梯坪", "lat": 24.4254, "lng": 121.8084 },
        { id: 8, "type": "user", "record": false, "name": "十分瀑布", "lat": 25.0401, "lng": 121.7722 },
        { id: 9, "type": "user", "record": false, "name": "深澳湾", "lat": 25.0316, "lng": 121.9108 }
    ];
    return (
        <div className={style.app}>
            <span>0</span>
            <YStyleds.Col style={{ background: "gray" }}>
                <PlacesInput type={0} />
                <PlacesInput type={1} />
                <PlacesInput type={2} />
            </YStyleds.Col>
            <span>1</span>
            <YStyleds.Row style={{ background: "gray" }}>
                <AlbumItem link={"http://"} name="Tommy 的相簿" />
                <AlbumItem onAdd={e => {
                    addModalType({
                        cls: "AddLink", arg: {
                            type: "album"
                        }
                    })
                }} />
            </YStyleds.Row>
            <span>2</span>
            <DateTimeSel label={"開始"} />
            <span>3</span>
            <DateTimeSel timeEnabled={false} label={"報名截止日"} />
            <span>4</span>
            {/* <EventItem /> */}
            <span>5</span>
            {/* <Folder /> */}
            <span>6</span>
            <FriendsIcon />
            <span>7</span>
            <Links links={[
                { rewilding_reference_links_title: "健行筆記", rewilding_reference_links_link: "https://hiking.biji.co/" },
            ]} editing={true} add={true} />
            <Links links={[
                { rewilding_reference_links_title: "健行筆記", rewilding_reference_links_link: "https://hiking.biji.co/" },
            ]} editing={false} add={true} />
            <span>8</span>
            <YStyleds.Row style={{ background: "gray", padding: "1rem" }}>
                <LogItem title="title" date="2024.07.26" point="大安森林公園" peoples={[{}]} />
            </YStyleds.Row>
            <MemberLimit />
            1
            <YStyleds.Row style={{ background: "gray", padding: "1rem" }}>
                <PotItem />
            </YStyleds.Row>
            2
            <PotViewItem type="selPot" />
            3
            <PotViewItem type="rank" />
            <SelRewildingMode />
            <span>FriendInfo:1</span>
            <FriendInfo type={1} />
            <span>FriendInfo:2</span>
            <FriendInfo type={2} />
            <span>FriendInfo:3</span>
            <FriendInfo type={3} />
            <span>FriendInfo:4</span>
            <FriendInfo type={4} />
           {/*  <MeetPoint data={data} set_data={set_data} items={items} />
            <MeetPoint type={2} data={data} set_data={set_data} items={items} /> */}
        </div>
    );
}

export default Tab5;